<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("Movie", 1) }} {{ $tc("Experience", 1) }}
        </div>
      </div>
      <div>
        <router-link
          variant="default"
          class="btn-blue"
          to="add-movie-experience"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getMovieExperiences"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>Movie Experience</th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="MovieExperiences.length > 0">
        <tr v-for="(item, key) in MovieExperiences" :key="key">
          <td>{{ item.movie_experience }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.movie_experience_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  item.movie_experience_is_active ? 'active' : 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-movie-experience', item)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="MovieExperiences.length == 0">
        <td colspan="2">
          {{ errors.message }}
          <NoRecords/>
          </td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      MovieExperiences: [],
      customErrors: {
        message: ""
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      searchValue: ""
    };
  },
  beforeMount() {
    this.getMovieExperiences();
    this.getviewingnumber();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getMovieExperiences();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieExperiences();
      } else {
        this.currentPage = event;
        this.getMovieExperiences();
      }
    },
    /* eslint-disable */
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { movie_experience_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: movie_experience_id
        }
      });
    },

    getMovieExperiences: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue
      };
      this.MovieExperiences = [];
      MasterService.GetAllMovieExperienceFormats(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data", data);
            if (
              data.Records &&
              data.Records.data &&
              data.Records.data.length > 0
            ) {
              this.MovieExperiences = data.Records.data;
              this.MovieExperiences.forEach(x => {
                x.movie_experience_is_active =
                  x.movie_experience_is_active === "Y" ? true : false;
              });
              if (data.Records.pagination && data.Records.pagination.total) {
                this.rows = data.Records.pagination.total;
                this.selectedvalue =
                  data.Records.pagination.total < 10
                    ? data.Records.pagination.total
                    : this.selectedvalue;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieExperienceComponent/ListMovieExperience.vue